import { render, staticRenderFns } from "./ModalSelectCOD.vue?vue&type=template&id=04faf7b9"
import script from "./ModalSelectCOD.vue?vue&type=script&lang=js"
export * from "./ModalSelectCOD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports